const content: { [key: string]: any } = {
  pageTitle: "Higher Award Tracking",
  globalAwardLegAndQcDetails: "Global Award Leg & QC Details",
  modalQCNC: {
    qualifictionCreditisNotCounting: "Qualification Credits Not Counting",
    creditsNotCounted:
      "Credits in this row are not counted toward your global award level because Number 2 businesses need to be qualified at the Founders Platinum level and EBR to earn the full value of credits in legs.",
    chinaLabels: {
      creditsNotCounted:
        "Credits in this row are not counted toward your global award level because Number 2 businesses need to be qualified at the Founders Senior Marketing Supervisor level and EBR to earn the full value of credits in legs.",
    },
  },
  foundersPlatinumLegsModal: {
    title: "Founders Platinum Legs",
    description:
      "In-market legs downline that have at least one qualified Founders Platinum. Founders Platinum Legs must be downline of a #1/#2 multiple business but do not include the #2 business itself or any internationally sponsored legs.",
    chinaLabels: {
      title: "Founders Senior Marketing Supervisor Legs",
      description:
        "In-market legs downline that have at least one qualified Founders Senior Marketing Supervisor. Founders Senior Marketing Supervisor Legs must be downline of a #1/#2 multiple business but do not include the #2 business itself or any internationally sponsored legs.",
    },
  },
  platinumLegsModal: {
    title: "Platinum Legs",
    description:
      "In-market legs downline that have at least one qualified Platinum. Platinum Legs must be downline of a #1/#2 multiple business but do not include the #2 business itself, any internationally sponsored legs, or legs that qualify as Founders Platinum legs.",
    chinaLabels: {
      title: "Senior Marketing Supervisor Legs",
      description:
        "In-market legs downline that have at least one qualified Senior Marketing Supervisor. Senior Marketing Supervisor Legs must be downline of a #1/#2 multiple business but do not include the #2 business itself, any internationally sponsored legs, or legs that qualify as Founders Senior Marketing Supervisor legs.",
    },
  },
  totalLegsModal: {
    title: "Total Legs Counting Towards GAR",
    description:
      "Width requirements for GAR are measured by Founders Platinum legs. After fulfilling requirement of 6 Founders Platinum legs to participate in GAR, an ABO may also use one Platinum leg towards their width requirement for their award.",
    chinaLabels: {
      description:
        "Width requirements for GAR are measured by Founders Senior Marketing Supervisor legs. After fulfilling requirement of 6 Founders Senior Marketing Supervisor legs to participate in GAR, an ABO may also use one Senior Marketing Supervisor leg towards their width requirement for their award.",
    },
  },
  modalGARViewYourStatus: {
    globalAwardRecognitionStatus: "Global Award Recognition Status",
    py: "PY{performanceYear}",
    awardLevel: "Award Level",
    totalLegsCounting: "Total Legs Counting",
    qualificationCredits: "Qualification Credits",
    qc: "QC",
    upTo: "Up to {qcCount} QC per leg",
    upToXQcPerLeg: "Up to {qcCount} QC per leg",
    disclaimer12QcMax:
      "To earn a max of 12 QC per leg, one must first qualify at F. Double Diamond with a maximum of 9 QC per leg and have 10 or more total legs counting.",
    disclaimer9QcMax:
      "To earn a max of 9 QC per leg one must first qualify at F. Executive Diamond with a maximum of 6 QC per leg and have 8 or more total legs counting.",
    awardLabels: {
      award393: "Executive Diamond",
      award398: "Founders Executive Diamond",
      award403: "Double Diamond",
      award408: "Founders Double Diamond",
      award413: "Triple Diamond",
      award418: "Founders Triple Diamond",
      award423: "Crown",
      award428: "Founders Crown",
      award433: "Crown Ambassador",
      award438: "Founders Crown Ambassador",
      chinaLabels: {
        award393: "Marketing Director",
        award398: "Founders Marketing Director",
        award403: "Advanced Marketing Director",
        award408: "Founders Advanced Marketing Director",
        award413: "Senior Marketing Director",
        award418: "Founders Senior Marketing Director",
        award423: "Crown",
        award428: "Founders Crown",
        award433: "Crown Ambassador",
        award438: "Founders Crown Ambassador",
      },
    },
    chinaLabels: {
      disclaimer12QcMax:
        "To earn a max of 12 QC per leg one must first qualify at F. Elite Marketing Director with a maximum of 9 QC per leg and have 12 or more F. Senior Marketing Supervisor legs.",
      disclaimer9QcMax:
        "To earn a max of 9 QC per leg one must first qualify at F. Marketing Director with a maximum of 6 QC per leg and have 8 or more F. Senior Marketing Supervisor legs.",
    },
  },
  hatGarOverviewView: {
    legAwardTracking: "Leg Award Tracking",
    lastMonthProcessed: "Last Month Processed: <1>{month}</1>",
    inMarketPinLevel: "In-Market Pin Level PY{performanceYear}",
    inMarketLegs: "In-Market Legs",
    totalLegs: "Total Legs",
    foundersLegs: "Founders (Q12) Legs",
    inMarketPinTrackingLevel: "In-Market Pin Tracking Level",
    viewLegs: "View Legs",
    globalAwardRecognitionStatus: "Global Award Recognition Status",
    globalAwardRecognitionTracking: "Global Award Recognition Tracking",
    onceYourBusinessQualifies:
      "Once your business qualifies as an Emerald Bonus Recipient, your Global Award Tracking tracking status will appear here.",
    garAwardLevel: "GAR Award Level PY{performanceYear}",
    foundersPlatinumLegs: "Founders Platinum Legs",
    platinumLegs: "Platinum Legs",
    totalLegsCounting: "Total Legs Counting towards GAR",
    qualifictionCreditisMax: "Qualification Credits at max of {qcMax} per leg",
    qualifictionCreditisMaxMobile: "QCs at max {maxLeg} per Leg",
    qualifictionCreditisNotCounting: "Qualification Credits Not Counting",
    qualifictionCreditisNotCountingMobile: "QCs Not Counting",
    foundersDiamondTrackingStatus: "Founders Diamond Tracking Status",
    globalAwardTrackingLevel: "Global Award Tracking Level",
    globalAwardTrackingLevelMobile: "GAR Tracking Level",
    viewLegsAndQCDetails: "View Legs and QC Details",
    viewYourStatus: "View Your Status",
    faqs: "FAQs",
    faqsAriaLabel: "Frequently Asked Questions",
    faqFileName: "Amway GAR - FAQs",
    brochure: "Brochure",
    brochureFileName: "Amway GAR - Brochure",
    chinaLabels: {
      platinumLegs: "Senior Marketing Supervisor Legs Tracking",
      foundersPlatinumLegs: "Founders Senior Marketing Supervisor Legs Tracking",
      foundersDiamondTrackingStatus: "Founders Senior Marketing Manager",
      onceYourBusinessQualifies:
        "Once your business qualifies as a Marketing Manager Bonus Recipient, your Global Award Tracking tracking status will appear here.",
    },
  },
  legTrackingView: {
    legTracking: "Leg Tracking",
    higherAwardTracking: "Higher Award Tracking",
    confidentialUser: "Confidential User",
    totalsSection: {
      year: "Year",
      inMarket: "In-Market",
      total: "Total",
      founders: "Founders (Q12)",
      py: "PY{performanceYear}",
    },
    inMarketLegs: "In-Market Legs",
    currentMonthProcessing: "Current Month Processing: <1>{month}</1>",
    nameNuberMarket: "ABO Name, Number, Market",
    year: "Year",
    percent: "{percent}%",
    py: "PY{performanceYear}",
    total: "Total",
    inMarketTotals: "In-Market Totals",
    internationalLegs: "International Legs",
    internationalAbo: "IA",
    internationalTotals: "International Totals",
    nonQualifiedMarket: "Non-Qualified In-Market Legs 9% And Above",
    showsNoQualification:
      "When the maximum bonus percentage shows with no qualification code please contact your account manager.",
    internationalBadge: "INT",
  },
  viewLegsView: {
    qualifiedLegOverview: "Qualified Leg Overview",
    performanceYear: "PY{performanceYear}",
    aboNameNumMarket: "{aboName} | {aboNum} | {market}",
    inMarketLegs: "In-Market Legs",
    currentMonthProcessing: "Current Month Processing: <1>{month}</1>",
    year: "Year",
    percent: "{percent}%",
    py: "PY{performanceYear}",
    inMarketTotals: "In-Market Totals",
    total: "Total",
    nonQualifiedInMarket: "Non-Qualified In-Market Legs 9% And Above",
    nonQualifiedInMarketTotals: "Non-Qualified In-Market Totals",
  },
  globalAwardAndQCDetailsView: {
    globalAwardAndQCDetails: "Global Award & QC Details",
    higherAwardTracking: "Higher Award Tracking",
    business: "{aboName} | {market} | {businessNature} | {aboNum}",
    trackingFoundersPlatinumLegs: "Tracking Founders Platinum Legs",
    trackingPlatinumLegs: "Tracking Platinum Legs",
    trackingFoundersPlatinum: "Tracking Founders Platinum",
    trackingEmeraldBonusRecipient: "Tracking Emerald Bonus Recipient",
    foundsPlatinumLegs: "Founders Platinum Legs",
    qualified: "Qualified",
    onTrack: "On Track",
    notTracking: "Not Tracking",
    notAvailable: "Not Available",
    primaryBusiness: "Primary Business",
    number2Business: "#2 Business",
    isdBusiness: "ISD Business",
    chinaLabels: {
      trackingFoundersPlatinumLegs: "Tracking Founders Senior Marketing Supervisor Legs",
      trackingFoundersPlatinum: "Tracking Founders Senior Marketing Supervisor",
      trackingEmeraldBonusRecipient: "Tracking Marketing Manager Bonus Recipient",
    },
    legDetail: {
      abosTracking: "ABOs Tracking",
      qualificationCreditsMultiplier: "QC Multiplier",
      numPlusQualificationCredits: "{credits}+ Qualification Credits",
      numQualificationCredits: "{credits} Qualification Credits",
      qualificationCredits: "Qualification Credits",
      notCounting: "Not Counting",
      counting: "Counting",
      showABOsTracking: "Show ABO's Tracking",
    },
  },
  hatView: {
    higherAwardTracking: "Higher Award Tracking",
    qualificationCreditDetails: "Qualification Credit Details",
    overview: {
      abosTracking: "ABOs Tracking",
      qualificationCreditsMultiplier: "Qualification Credits Multiplier",
      platinum: "{platinums} Platinums",
      foundersPlatinum: "{fPlatinums} F. Platinums",
      foundersPlatinumAndPlatinums: "F. Plat. / Plat. (max 3 QCs)",
      emeraldBonusRecipients: "{emeralds} EBRs",
      diamondBonusRecipients: "{diamonds} DBRs",
      foundersDiamondBonusRecipients: "{fDiamonds} F. DBRs",
      chinaLabels: {
        foundersPlatinum: "{fPlatinums} Founders' Senior Marketing Supervisor",
        foundersPlatinumAndPlatinums:
          "Founders' Senior Marketing Supervisor / Senior Marketing Supervisor. (max 3 QCs)",
        platinum: "{platinums} Senior Marketing Supervisors",
        emeraldBonusRecipients: "{emeralds} Marketing Manager Bonus Recipients",
        diamondBonusRecipients: "{diamonds} Senior Marketing Manager Bonus Recipients",
        foundersDiamondBonusRecipients: "{fDiamonds} Founders' Senior Marketing Manager Bonus Recipients",
      },
    },
    tabs: {
      platinums: "Platinums",
      fPlatinums: "F. Platinums",
      ebrs: "EBRs",
      dbrs: "DBRs",
      fDBRs: "F. DBRs",
      chinaLabels: {
        platinums: "Senior Marketing Supervisor",
        fPlatinums: "Founders' Senior Marketing Supervisor",
        ebrs: "Marketing Manager Bonus Recipients",
        dbrs: "Senior Marketing Manager Bonus Recipients",
        fDBRs: "Founders' Senior Marketing Manager Bonus Recipients",
      },
    },
    trackingPlatinums: "Tracking Platinums",
    trackingFPlatinums: "Tracking F. Platinums",
    trackingEBRs: "Tracking EBRs",
    trackingDBRs: "Tracking DBRs",
    trackingFDBRs: "Tracking F. DBRs",
    hatList: {
      aboNameNumber: "ABO Name / Number",
      market: "Market",
      viewLegs: "View Legs",
      uplineDiamond: "Upline Diamond",
      inMarketQLegsTracking: "In-Market Q Legs Tracking",
      veEligible: "VE Eligible",
      fptStatus: "F. PT Status",
      yes: "Yes",
      no: "No",
      foundersPlatinumStatus: "Founders Platinum Status",
      noEBRs: "Currently there are no Emerald Bonus Recipients tracking in this leg.",
      noDBRs: "Currently there are no Diamond Bonus Recipients tracking in this leg.",
      noFDBRs: "Currently there are no Founders Diamond Bonus Recipients tracking in this leg.",
      noFPlatinums: "Currently there are no F. Platinums tracking in this leg.",
      noPlatinums: "Currently there are no Platinums tracking this in leg.",
      chinaLabels: {
        uplineDiamond: "Upline Senior Marketing Manager",
        foundersPlatinumStatus: "Founders' Senior Marketing Supervisor Status",
        noEBRs: "Currently there are no Marketing Manager Bonus Recipients tracking in this leg.",
        noDBRs: "Currently there are no Senior Marketing Manager Bonus Recipients tracking in this leg.",
        noFDBRs: "Currently there are no Founders' Senior Marketing Manager Bonus Recipients tracking in this leg.",
        noFPlatinums: "Currently there are no Founders' Senior Marketing Supervisors tracking in this leg.",
        noPlatinums: "Currently there are no Senior Marketing Supervisors tracking this in leg.",
      },
    },
  },
  termsAndConditions: {
    title: "Terms & Conditions",
    disclaimer:
      "THIS IS THE PROPERTY OF ALTICOR INC. (“AMWAY”). The information contained in these pages includes Line of Sponsorship (“LOS”) Information, which constitutes the trade secret, confidential information, and proprietary business information of Amway that is developed, compiled, maintained, and owned exclusively by Amway and protected under the applicable ABO Rule of Conduct. By Viewing or obtaining this information, you understand that the information is Amway’s property and agree to maintain the information contained herein in the strictest confidence and to take all necessary steps and appropriate measures to safeguard the information and maintain the confidentiality thereof. You agree not to compile, organize, access, creates lists of, or otherwise use or disclose the LOS Information contained within except as authorized by Amway, and only as necessary to facilitate your Amway Business and only in accordance with the applicable ABO Rules of Conduct. Use of LOS information with any other business or activity is strictly prohibited.",
    dismissBtn: "Dismiss",
    agreeBtn: "I Understand",
  },
  achieved: "Achieved",
  tracking: "On Track",
  notTracking: "Not Tracking",
  error: {
    timeout: "The connection has timed out.",
    unableToLoad: "We are unable to load HAT/GAR data for your business. Please try again later.",
    noData: "We are unable to load your downline data for this business.",
    refresh: "Refresh",
  },
};

export default content;
